import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientStudentList = async (
  { rootGetters },
  { clientSid, subjects, classes, cocurriculums, readFromCache, queryParam }
) => {
  const axios = rootGetters['app/stbAxios'];
  const apiUrl = process.env.API_URL || '';
  const stbApi = stbAPIGateway(axios, apiUrl);
  const response = await stbApi.getClientStudentList(
    clientSid,
    { subjects, classes, cocurriculums, readFromCache },
    queryParam
  );
  return response;
};
